import { ApiAdapter } from '../ApiAdapter';

export class DepositCustomerSDK {
  constructor(private apiAdapter: ApiAdapter) {}

  async recordActivity(tokenId: string): Promise<void> {
    return this.apiAdapter.post(
      `/deposit-customers/token/${tokenId}/activity`,
      undefined,
      'Failed to record activity for deposit customer',
    );
  }
}
